import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const traineeService = {
    getAll,
    create,
    get,
    update,
    deleteClient
};

function getAll(data)
{
    return axios.get('/api/services/app/Trainee/GetAll', {
        params: {
            QueryString: data.query,
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            Sorting: data.sorting
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function create(data)
{
    return axios.post('/api/services/app/Trainee/Create',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function get(id)
{
    return axios.get('/api/services/app/Trainee/Get', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })
}
function update(data)
{
    return axios.put('/api/services/app/Trainee/Update',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteClient(id)
{
    return axios.delete('/api/services/app/Trainee/Delete', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })
}